import {load} from '@shopify/theme-sections';
import '../../styles/templates/index.pcss';
import '../sections/slideshow';

load('*');
